import { Typography } from '@mui/material';
import * as React from 'react';

interface Props {
  showLabel?: boolean;
  countyname?: string;
  state?: string;
}

export function CountyLabel(props: Props) {
  const { showLabel, countyname, state } = props;
  return (
    <>
      {showLabel && (
        <Typography
          sx={{ fontWeight: 500 }}
          variant={'body2'}
          data-test={'county-label'}
        >
          County
        </Typography>
      )}
      <Typography
        data-test={'county-value'}
        sx={{fontWeight: 500}}
      >
        {countyname + ' County, ' + state}
      </Typography>
    </>
  );
}
